import { useState } from 'react';
import { Icon } from '../../../shared/Icon';
import type { ExercisePluginProps } from '../types';
import { objects, text } from '../contentFields';
import { VocabularyExposureExercise } from './VocabularyExposureExercise';

export function GuidedExposureExercise(props: ExercisePluginProps) {
  if (props.exercise.content.vocabularyExposure) return <VocabularyExposureExercise {...props} />;
  return <AuthoredGuidedExposureExercise {...props} />;
}

function AuthoredGuidedExposureExercise({ exercise, onComplete }: ExercisePluginProps) {
  const [selected, setSelected] = useState<number | null>(null);
  const [saving, setSaving] = useState(false);
  const dialogue = objects(exercise.content, 'dialogue');
  const question = exercise.content.noticingQuestion as { prompt?: string; options?: string[]; correctIndex?: number } | undefined;
  const correctIndex = Number(exercise.evaluation.correctIndex ?? question?.correctIndex ?? -1);
  const correct = selected === correctIndex;

  async function finish() {
    if (selected === null) return;
    setSaving(true);
    await onComplete({
      response: { selectedIndex: selected },
      result: { correct, selectedIndex: selected, correctIndex },
      evidence: exercise.targets.map(itemId => ({ itemId, dimension: 'recognized', value: correct ? 0.8 : 0.2 }))
    });
  }

  return <>
    <p className="exercise-kicker">MØT SPRÅKET I EN SITUASJON</p>
    <h2 className="exercise-title">{text(exercise.content, 'title', 'Legg merke til uttrykket.')}</h2>
    <p className="exercise-intro">{text(exercise.content, 'situation')}</p>
    <div className="dialogue-card">
      {dialogue.map((turn, index) => <p key={index}><strong>{text(turn, 'speaker')}</strong><span>{text(turn, 'text')}</span></p>)}
    </div>
    <div className="model-answer"><span>UTTRYKKET</span><p>{text(exercise.content, 'highlight')}</p></div>
    <p className="exercise-intro">{text(exercise.content, 'explanation')}</p>
    <fieldset className="choice-list">
      <legend>{question?.prompt ?? 'Hva la du merke til?'}</legend>
      {(question?.options ?? []).map((option, index) => <button type="button" key={option} className={selected === index ? 'selected' : ''} onClick={() => setSelected(index)}>{option}</button>)}
    </fieldset>
    {selected !== null && <div className={`feedback-box ${correct ? '' : 'evaluation-pending'}`}><h4>{correct ? String(exercise.feedback.success ?? 'Riktig.') : 'Se på kontrasten én gang til.'}</h4><p>{String(exercise.feedback.explanation ?? '')}</p></div>}
    <div className="speak-actions"><button className="exercise-next" disabled={selected === null || saving} onClick={finish}>Fortsett <Icon name="arrow" /></button></div>
  </>;
}
